<pt-feature-info />
<pt-breadcrumbs class="bg-white" [breadcrumbs]="breadcrumbs$ | async" />
<div class="border-b border-solid border-slate-300"></div>

<div class="mx-auto flex max-w-4xl flex-col gap-4 p-4">
  <h1 class="mat-headline-4 !mb-0">Deposit Settings</h1>

  @if (brandUid(); as brandUid) {
    @if (currency(); as currency) {
      <pr-deposit-settings-form
        #depositForm
        [value]="depositSettings()"
        [currency]="currency"
        [brandUid]="brandUid"
        [reasons]="schedulingEventReasons()"
        [treatmentTemplates]="treatmentTemplates()"
        [treatmentConfigurations]="treatmentConfigurations()"
        [hasReminderAutomation]="hasReminderAutomation()"
        [busy]="saving()"
        (createReminderAutomation)="createReminderAutomation()"
      />

      <pr-content-container margin="mb-2" class="sticky bottom-0 z-50">
        <pt-buttons-container padding="none">
          <button
            type="button"
            mat-flat-button
            color="primary"
            [disabled]="(depositForm.canSave$ | async) !== true"
            (click)="saveDepositSettings(depositForm)"
          >
            Save Changes
          </button>
        </pt-buttons-container>
      </pr-content-container>
    }
  }
</div>
